'use client';

import type { FC } from 'react';

import config from '@packages/config';
import { LocaleSwitchLink } from './IndividualLinks/LocaleSwitchLink.client';
import { AccountLink } from './IndividualLinks/AccountLink.client';
import { WishlistLink } from './IndividualLinks/WishlistLink.client';
import { BasketLink } from './IndividualLinks/BasketLink.client';
import { ServiceLink } from './IndividualLinks/ServiceLink.client';
import { JoeLink } from './IndividualLinks/JoeLink.client';
import { PaybackLink } from './IndividualLinks/PaybackLink.client';
import { useIsCheckoutRoute } from '../DesktopSlots/Base/useIsCheckoutRoute';

export const MetaNavigationLinks: FC = () => {
  const {
    headerSlots: { payback, localeSwitcher, joe, serviceApi },
  } = config;

  // TODO handle differently at some point, to make this RSC-compatible
  const isCheckoutRoute = useIsCheckoutRoute();

  return (
    <div className="lg:hidden">
      <ul>
        {localeSwitcher && <LocaleSwitchLink />}
        <AccountLink />
        <WishlistLink />
        {!isCheckoutRoute && <BasketLink />}
        {serviceApi && <ServiceLink />}
        {joe && <JoeLink />}
        {payback && <PaybackLink />}
      </ul>
    </div>
  );
};
